import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'El Bono 3 me salvó. Tenía el parcial en dos días. Seguí el cronograma hora por hora y aprobé con 8.',
    author: 'Lucas M.',
    location: 'UNLP',
    initial: 'L'
  }, {
    quote: 'El simulacro del Bono 6 era casi idéntico al parcial real. Cuando vi las preguntas me reí porque ya las había respondido.',
    author: 'Pablo A.',
    location: 'Rosario',
    initial: 'P'
  }, {
    quote: 'Por fin entendí la diferencia entre las dos tópicas de Freud. Llevaba dos cuatrimestres confundiéndolas.',
    author: 'Camila R.',
    location: 'UNC',
    initial: 'C'
  }, {
    quote: 'Las flashcards las usé en el colectivo y en la sala de espera. Cuando llegué al parcial las respuestas salían solas.',
    author: 'Martín G.',
    location: 'Tucumán',
    initial: 'M'
  }];
  const Stars = () => <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-317">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-318" />)}
    </div>;
  return <section className="py-14 px-4 max-w-6xl mx-auto bg-black" data-id="element-319">
      <FadeIn data-id="element-320">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-321">
          <span className="text-red-500" data-id="element-322">❤️</span> LO QUE DICEN LOS QUE YA LO
          TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-323">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-324">
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 h-full" data-id="element-325">
              <Stars data-id="element-326" />
              <p className="text-lg text-gray-200 mb-6 italic leading-relaxed" data-id="element-327">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-328">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 font-bold" data-id="element-329">
                  {t.initial}
                </div>
                <div data-id="element-330">
                  <p className="font-bold text-white" data-id="element-331">{t.author}</p>
                  <p className="text-sm text-gray-500" data-id="element-332">{t.location}</p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}